import React, { useEffect } from 'react'
import { Container, Box, Typography, } from '@mui/material';
import Grid from '../../../common/CustomGrid'; 
import AOS from 'aos';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
import 'swiper/css';
import Preloader from '../../../common/Preloader'; 
import RawMarkup from '../../../common/RawMarkup'
import { FreeMode, Scrollbar, Mousewheel } from 'swiper/modules';
import ImageWithPlaceholder from '../../../common/ImageWithPlaceholder';

const AboutUsSection = ({data}) => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);

  if (!data) { return (  <Preloader /> ); }

  const ScrollableContent = ({content}) => {
    return (
      <Box className="page-content">
        <Swiper
        direction="vertical"
        slidesPerView="auto" 
        freeMode={true} 
        mousewheel={true} 
        scrollbar={{ draggable: true }} 
        modules={[FreeMode, Scrollbar, Mousewheel]}
        style={{ height: '300px' }} 
        className="swiper-scroll"
      >
        <SwiperSlide>
          <Box sx={{paddingRight: 4, textAlign: 'left'}}>
            {content}
          </Box>
          
        </SwiperSlide>
      </Swiper>
    </Box>   
    )
  }

  const { title = "Nosotros", description="", team = []  } = data || {};

  return (
    <Box id="about" className="about-section" sx={{ backgroundColor: '#f4f6fc', py: 8, px: { xs: 2, md: 6 },  }} >
      <Container>
        <Typography data-aos="fade-up" variant="h3" className='homepage-section-title' sx={{mb: 3}} >
          {title}
        </Typography>
        <Typography data-aos="fade-up" variant="body1" sx={{ textAlign: 'center', maxWidth: '860px', mx: 'auto', lineHeight: 1.6, mb: 8, }}>
          <RawMarkup content={description} />
        </Typography>
        <Grid container spacing={4}>
          {team.map((item, index) => {
            const {description, image, name} = item
            const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
            const imageUrl = image?.url  ? `${baseUrl}${image.url}`   : ""; 
            return (
            <Grid size={{ xs: 12, md: 4 }} data-aos="fade-up" key={index} >
              <Box sx={{ textAlign: 'center' }}>
                <ImageWithPlaceholder src={imageUrl}  alt={name}  size={'100%'}  iconSize={50} borderRadius="50%"  />
                <ScrollableContent content={<>
                  <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                    <RawMarkup content={description} containerType="span"/> 
                  </Typography>
                </> }/>              
              </Box>
            </Grid>
          )})}
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutUsSection;
